var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoNs = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 26, height: 18, viewBox: "0 0 26 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.903 4C11.638 4 12.317 4.282 12.884 4.847V4.848L15.821 7.785L15.8287 7.79007C15.9961 7.90039 16.1624 8.01 16.385 8.01H21.753L17.74 4H20.623L25.596 8.97L20.623 13.998H14.69C13.956 13.998 13.277 13.717 12.712 13.151L9.832 10.214C9.662 10.044 9.436 9.987 9.21 9.987H3.842L7.854 13.997H5.03L0 8.97L5.03 4H10.903ZM11.4718 6.25905C11.3018 6.09105 11.1327 5.97705 10.9058 5.97705H5.82175L3.84375 8.00905H9.21175C10.0597 8.00905 10.6807 8.29005 11.2448 8.85705L14.1267 11.7371C14.2968 11.9071 14.4668 11.9641 14.7467 11.9641H19.7767L21.7547 9.98605H16.3867C15.5388 9.98605 14.9188 9.70305 14.3518 9.13905L11.4718 6.25905Z", fill: "#000066" }))),
        alt: 'Ns',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoNs;
//# sourceMappingURL=index.js.map